"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const options_component_1 = __importDefault(require("./options-component"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const MenuListComponent = (props) => {
    var _a;
    const { children, isLoading, label } = props;
    const loadingCountElements = (((_a = props.selectProps) === null || _a === void 0 ? void 0 : _a.pageSize) || 0) + 1;
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default.optionsDropdown },
        !isLoading && label && (react_1.default.createElement("div", { className: styles_modules_less_1.default.optionsLabel }, label)),
        children,
        isLoading && (react_1.default.createElement(react_1.default.Fragment, null, Array(loadingCountElements)
            .fill(0)
            .map((item, index) => {
            return react_1.default.createElement(options_component_1.default, { key: index, isLoading: true });
        })))));
};
exports.default = MenuListComponent;
